import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormLogin } from '../components/canje/FormLogin';
import { FormInvitados } from '../components/canje/FormInvitados';
import { Result } from '../components/canje/Result';
import { Estado } from '../types/Estado';
import { FormOTP } from '../components/canje/FormOTP';
import { CANJE_SUCCESS_MSG } from '../components/shared/Constantes';
import { ResponseLogin } from '../rest/models/ResponseLogin';
import { StatusContext } from '../components/shared/Layout';
import { GlassBox } from '../components/shared/GlassBox';

export const CanjePage = () => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [token, setToken] = useState<string | undefined>();
  const [paso, setPaso] = useState<Estado | null>(null);
  const [cantMaxInvitados, setCantMaxInvitados] = useState<number>(0);
  const focusOn = useRef<HTMLDivElement | null>(null);
  const appStatus = useContext(StatusContext);

  useEffect(() => {
    appStatus?.availableService === true ? setPaso(Estado.Login) : setPaso(Estado.StopEvent);
  }, [appStatus]);

  useEffect(() => {
    if (paso === 0)
      focusOn.current?.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      });
  }, [paso]);

  const handleLogin = (response: ResponseLogin) => {
    setToken(response?.loginResponse?.token);
    if (response?.loginResponse?.cantidadMaximaInvitados) {
      setCantMaxInvitados(response?.loginResponse?.cantidadMaximaInvitados);
    }
    setPaso(Estado.OTP);
  };

  const handleOtp = (token?: string) => {
    setToken(token);
    setPaso(Estado.Canje);
  };

  const handleCanje = (result: boolean | undefined) => {
    const resultSafe: boolean = result?.toString() === 'true';
    if (resultSafe) setPaso(Estado.Success);
    else handleError();
  };

  const handleError = (message?: string) => {
    setErrorMessage(message);
    setPaso(Estado.Error);
  };

  const getStepComponent = () => {
    if (paso === null) return <></>;
    if (paso === Estado.StopEvent) return <Result message={appStatus?.message} />;
    if (paso === Estado.Login) return <FormLogin loginCallback={handleLogin} handleError={handleError} />;
    if (paso === Estado.OTP) return <FormOTP otpCallback={handleOtp} handleError={handleError} token={token} />;
    if (paso === Estado.Canje)
      return <FormInvitados canjeCallback={handleCanje} handleError={handleError} token={token} cantMaxInvitados={cantMaxInvitados} />;
    if (paso === Estado.Success) return <Result message={CANJE_SUCCESS_MSG} />;
    if (paso === Estado.Error) return <Result message={errorMessage} />;
  };

  return (
    <GlassBox
      m={'0px auto'}
      maxWidth={['100%', '555px']}
      minHeight={['500px']}
      p={['32px', '48px']}
      bg={'white'}
      borderRadius={'8px 32px 8px 32px'}
      ref={focusOn}
    >
      {getStepComponent()}
    </GlassBox>
  );
};
